export default "__VITE_ASSET__Geyvp$ZK__"